"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Styles = require("../utils/Styles");

var _UIIcon = _interopRequireDefault(require("./UIIcon"));

var _IconConstants = require("./IconConstants");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 1em;\n  width: 1em;\n  margin: 0.25em 0.125em 0;\n  transform-origin: 50% 38%;\n  transform: ", " translateY(-6.3%);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-flex;\n  line-height: 1;\n  user-select: none;\n  position: relative;\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-style: ", ";\n  border-width: ", ";\n  font-size: ", ";\n  padding: ", ";\n  transform: ", ";\n  vertical-align: ", ";\n\n  &.private-icon-circle--legacy {\n    display: inline-flex;\n    align-items: center;\n    height: 2em;\n    justify-content: center;\n    width: 2em;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Outer = _styledComponents.default.span.withConfig({
  displayName: "UIIconHolder__Outer",
  componentId: "sc-1rm3efc-0"
})(_templateObject(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var borderColor = _ref2.borderColor;
  return borderColor;
}, function (_ref3) {
  var borderRadius = _ref3.borderRadius;
  return borderRadius;
}, function (_ref4) {
  var borderStyle = _ref4.borderStyle;
  return borderStyle;
}, function (_ref5) {
  var borderWidth = _ref5.borderWidth;
  return (0, _Styles.toPx)(borderWidth);
}, function (_ref6) {
  var size = _ref6.size;
  return size != null && (_IconConstants.ICON_SIZES[size] || size) + "px";
}, function (_ref7) {
  var padding = _ref7.padding;
  return padding != null && padding + "em";
}, function (_ref8) {
  var rotate = _ref8.rotate;
  return rotate != null && "rotate(" + rotate + "deg)";
}, function (_ref9) {
  var verticalAlign = _ref9.verticalAlign;
  return verticalAlign;
});

var getIconTransform = function getIconTransform(_ref10) {
  var rotate = _ref10.rotate,
      rotateLock = _ref10.rotateLock;
  return rotate != null && !rotateLock ? "rotate(" + rotate * -1 + "deg)" : null;
};

var Icon = (0, _styledComponents.default)(function (props) {
  var __rotate = props.rotate,
      __rotateLock = props.rotateLock,
      rest = (0, _objectWithoutProperties2.default)(props, ["rotate", "rotateLock"]);
  return _react.default.createElement(_UIIcon.default, rest);
}).withConfig({
  displayName: "UIIconHolder__Icon",
  componentId: "sc-1rm3efc-1"
})(_templateObject2(), getIconTransform);

var UIIconHolder = _react.default.memo(function (_ref11) {
  var color = _ref11.color,
      innerClassName = _ref11.innerClassName,
      innerStyles = _ref11.innerStyles,
      name = _ref11.name,
      rotate = _ref11.rotate,
      rotateLock = _ref11.rotateLock,
      size = _ref11.size,
      rest = (0, _objectWithoutProperties2.default)(_ref11, ["color", "innerClassName", "innerStyles", "name", "rotate", "rotateLock", "size"]);
  return _react.default.createElement(Outer, (0, _extends2.default)({}, rest, {
    rotate: rotate,
    size: size
  }), _react.default.createElement(Icon, {
    className: innerClassName,
    color: color,
    name: name,
    rotate: rotate,
    rotateLock: rotateLock,
    size: size,
    style: innerStyles
  }));
});

UIIconHolder.propTypes = {
  backgroundColor: _propTypes.default.string,
  borderColor: _propTypes.default.string,
  borderRadius: _propTypes.default.string,
  borderStyle: _propTypes.default.oneOf(['solid', 'double', 'dashed', 'dotted', 'initial', 'inherit', 'unset']),
  borderWidth: _propTypes.default.number,
  verticalAlign: _propTypes.default.string,
  classname: _propTypes.default.string,
  color: _UIIcon.default.propTypes.color,
  innerClassName: _propTypes.default.string,
  name: _UIIcon.default.propTypes.name,
  padding: _propTypes.default.number,
  rotate: _propTypes.default.number,
  rotateLock: _propTypes.default.bool,
  size: _UIIcon.default.propTypes.size,
  innerStyles: _propTypes.default.object
};
UIIconHolder.defaultProps = {
  padding: 0.5,
  rotate: 0,
  borderStyle: 'solid',
  borderWidth: 0
};
UIIconHolder.displayName = 'UIIconHolder';
var _default = UIIconHolder;
exports.default = _default;
module.exports = exports.default;